var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['wrapper', { checked: _setup.props.checked }, { focus: _setup.props.focus }]},[(_setup.props.checked)?_c(_setup.CheckBold):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }